/* --------------------------------------------------------------------------
   TT-BUNDLE-MODAL — open the Signature Bundles explainer from the megamenu.

   Josh, 2026-08-18: the banner should open a modal explaining the bundles
   rather than jumping to an anchor on one product page.

   PROGRESSIVE, AND THE FALLBACK IS THE ORIGINAL BEHAVIOUR. The banner is still
   an <a href="/products/…#bundles">. This file intercepts the click only when
   the dialog is in the DOM and the browser supports showModal(); otherwise the
   link navigates exactly as it did before, to a page that answers the same
   question at more length.

   Everything modal-shaped — the focus trap, Escape, returning focus to the
   banner on close, making the page behind inert — is what <dialog>.showModal()
   already does. None of it is reimplemented here.
   -------------------------------------------------------------------------- */

(function () {
  'use strict';

  if (window.__ttBundleModal) return;
  window.__ttBundleModal = true;

  function dialog() {
    var d = document.getElementById('tt-bundle-modal');
    return d && typeof d.showModal === 'function' ? d : null;
  }

  document.addEventListener('click', function (event) {
    /* Leave modified clicks alone: the banner is a real URL and somebody
       middle-clicking it wants the page in a tab, not a dialog. */
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    var close = event.target.closest('[data-bundle-close]');
    if (close) {
      var open = close.closest('dialog');
      if (open) open.close();
      return;
    }

    var trigger = event.target.closest('[data-bundle-open]');
    if (!trigger) return;
    var d = dialog();
    if (!d) return;                       /* no dialog, no support: let the link win */
    event.preventDefault();

    /* The megamenu is still open behind the modal and would sit over it, or
       reopen on the next pointer move. Close it the way its own script does. */
    document.dispatchEvent(new CustomEvent('tt:mega:close'));
    d.showModal();
  });

  /* Clicking the backdrop closes. A <dialog> reports backdrop clicks as clicks
     on the dialog ITSELF, so the test is whether the pointer landed outside the
     element's own box rather than on any particular child. */
  document.addEventListener('click', function (event) {
    var d = event.target;
    if (!d || d.tagName !== 'DIALOG' || !d.open) return;
    var r = d.getBoundingClientRect();
    var inside = event.clientX >= r.left && event.clientX <= r.right
              && event.clientY >= r.top && event.clientY <= r.bottom;
    /* A keyboard-triggered click reports 0,0 and would read as "outside". */
    if (!inside && (event.clientX || event.clientY)) d.close();
  });
})();
